<template>
  <div class="max-h-20 overflow-y-auto ">
      <template v-for="(item, idx) in items" >
          <p :key="`${idx}-${item.value}`" class="mt-1 truncate text-md text-gray-500">{{item.value}}</p>
      </template>
  </div>
</template>
<script>
export default {
  name: 'subtitle-home',
  data() {
    return {
      items: []
    }
  },

  created() {
    this.getInfo(),
    this.interval()
  },
  methods: {
    async getInfo() {
      let config = {
        params: {
          ...this.$store.state.data,
          blueprint: this.$route.params.blueprint,
          recordid: this.$route.params.record,
          query: this.$route.query,
        }
      }
      const response = await this.$http.get('/flow/custom/subtitle_home', config)

      this.items = response.data
    },
    interval: function(){
      setInterval(function () {
        this.getInfo()
      }.bind(this), 60000);
    },
  }
}
</script>
